/* Craftsbazaar team page — scroll reveal. Scoped to .cb-team, safe with multiple instances. */
(function () {
  function init(root) {
    root.classList.add('is-js');
    var els = root.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function boot() {
    document.querySelectorAll('.cb-team').forEach(init);
  }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); 
    
  }
})();
